import Fab from "@material-ui/core/Fab";
import Paper from "@material-ui/core/Paper";
import { ThemeProvider } from "@material-ui/core/styles";
import {
    DataGrid,
    GridFilterToolbarButton,
    GridToolbarContainer,
} from "@material-ui/data-grid";
import MonitorHeartIcon from "@material-ui/icons/AccessAlarms";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import React, { Fragment, useEffect } from "react";
import { AuthContext } from "../../App";
import { siteFindAll } from "../../services/SiteService";
import { Pagina } from "../template/Template";

import "../../App.css";

import Dialogo from "./site/Dialogo";
import DialogoMonitoramento from "./site/DialogoMonitoracao";

import { format } from "date-fns";

import { Tooltip } from "@material-ui/core";
import { Loading } from "../Loading";
import { ShowMessageBox } from "../ShowMessageBox";

import { useStyles } from "../styles/StyleSite";
import { theme } from "../styles/Theme";


let inserir = false;
let severity = "success";
let msg = "";

export default function Site() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    const [listSite, setListSite] = React.useState([]);
    const [selection, setSelection] = React.useState({});

    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDialogAssignUserToSite, setOpenDialogAssignUserToSite] =
        React.useState(false);
    const [openDialogMonitoramento, setOpenDialogMonitoramento] =
        React.useState(false);
    const [openLoading, setOpenLoading] = React.useState(false);

    const closeDialog = () => {
        inserir = false;
        setOpenDialog(false);
    };

    console.log(openDialogAssignUserToSite);

    const closeDialogAssignUserToSite = () => {
        inserir = false;
        setOpenDialogAssignUserToSite(false);
    };

    console.log(closeDialogAssignUserToSite);

    const closeDialogMonitoramento = () => {
        setOpenDialogMonitoramento(false);
    };

    useEffect(async () => {
        setOpenLoading(true);
        const respSite = await siteFindAll();
        setListSite(respSite.data);

        setOpenLoading(false);
    }, []);

    const Content = () => {
        const [selectionItem, setSelectionItem] = React.useState({});
        const [selected, setSelected] = React.useState(false);

        const newRecord = () => {
            setOpenSnackBar(false);
            inserir = true;
            setSelection({
                sit_id: null,
                fab_nome: null,
                sit_prim_analise: false,
                sit_dt_ultima_operacao: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
                sit_dt_cadastro: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
                sit_nome: null,
                sit_ajuste_horario: null,
            });
            setOpenDialog(true);
        };

        const editRecord = () => {
            inserir = false;
            setSelected(false);
            setSelection(selectionItem);
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        // const assignUserToSite = () => {
        //   inserir = false;
        //   setSelection(selectionItem);
        //   setOpenSnackBar(false);
        //   setOpenDialogAssignUserToSite(true);
        // };

        const editMonitoramento = () => {
            setSelection(selectionItem);
            setOpenSnackBar(false);
            setOpenDialogMonitoramento(true);
        };

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };

        const filteredSitesId = listSite.filter(
            (option) => option.sit_id !== "999999"
        );

        return (
            <Fragment>
                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <Loading open={openLoading} />

                <Dialogo
                    selection={selection}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    listSite={listSite}
                    setListSite={setListSite}
                    inserir={inserir}
                    closeDialog={closeDialog}
                />
                <DialogoMonitoramento
                    selection={selection}
                    openDialogMonitoramento={openDialogMonitoramento}
                    closeDialogMonitoramento={closeDialogMonitoramento}
                />
                <div>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div className={classes.boxDataGrid}>
                            <ThemeProvider theme={theme}>
                                <DataGrid
                                    rows={filteredSitesId}
                                    disableColumnMenu
                                    disableColumnReorder
                                    id="sit_id"
                                    pageSize={15}
                                    rowHeight={50}
                                    pageSizeOptions={[5]}
                                    onRowSelected={(newSelection) => {
                                        setSelectionItem(newSelection.data);
                                        setSelected(true);
                                    }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                    }}
                                    columns={[
                                        {
                                            field: "sit_id",
                                            headerName: "Id do Site",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                            sortable: false,
                                        },
                                        {
                                            field: "sit_nome",
                                            headerName: "Nome Site",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },
                                        {
                                            field: "sit_container_delimitador",
                                            headerName: "Separador",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },
                                        {
                                            field: "sit_caracter",
                                            headerName: "CharSet",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },

                                        {
                                            field: "sit_ajuste_horario",
                                            headerName: "Horario",
                                            headerClassName: "header_grid",
                                            type: "number",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },
                                        {
                                            field: "fab_nome",
                                            headerName: "Fabricante",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },
                                        {
                                            field: "sit_prim_analise",
                                            headerName: "Primeira Análise",
                                            headerClassName: "header_grid",
                                            type: "boolean",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                        },
                                        {
                                            field: "sit_origem",
                                            headerName: "Origem",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            align: "center",
                                            flex: 1,
                                            minWidth: 30,
                                            valueFormatter: (params) => params.value === "C" ? "Cliente" : params.value === "E" ? "Ebco" : "NF",
                                        },
                                        {
                                            field: "sit_monitor",
                                            headerName: "Monitor",
                                            headerClassName: "header_grid",
                                            type: "boolean",
                                            headerAlign: "center",
                                            align: "center",
                                            flex: 1,
                                            minWidth: 30,
                                        },
                                        {
                                            field: "sit_dt_cadastro",
                                            headerName: "Cadastro",
                                            headerClassName: "header_grid",
                                            type: "date",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                            sortable: false,
                                            valueFormatter: (params) => {
                                                if (!(params.value == null)) {
                                                    return format(
                                                        new Date(params.value),
                                                        "dd/MM/yy-HH:mm"
                                                    );
                                                }
                                                return null;
                                            },
                                        },
                                        {
                                            field: "sit_dt_ultima_operacao",
                                            headerName: "Última Atualização",
                                            headerClassName: "header_grid",
                                            type: "date",
                                            headerAlign: "center",
                                            flex: 1,
                                            minWidth: 100,
                                            sortable: false,
                                            valueFormatter: (params) => {
                                                if (!(params.value == null)) {
                                                    return format(
                                                        new Date(params.value),
                                                        "dd/MM/yy-HH:mm"
                                                    );
                                                }
                                                return null;
                                            },
                                        },
                                    ]}
                                />
                            </ThemeProvider>
                            <div style={{ width: "100%" }}>
                                <div className={classes.fab}>
                                    <Tooltip title="Novo Site">
                                        <Fab
                                            color="primary"
                                            aria-label="add"
                                            variant="extended"
                                            onClick={newRecord}
                                            style={{ margin: "5px", height: "40px" }}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="Editar Site">
                                        <Fab
                                            color="primary"
                                            aria-label="edit"
                                            disabled={!selected}
                                            onClick={editRecord}
                                            variant="extended"
                                            style={{ margin: "5px", height: "40px" }}
                                        >
                                            <EditIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="Novo Monitor">
                                        <Fab
                                            color="primary"
                                            aria-label="addmonitor"
                                            disabled={!selected}
                                            variant="extended"
                                            onClick={editMonitoramento}
                                            style={{ margin: "5px", height: "40px" }}
                                        >
                                            <MonitorHeartIcon />
                                        </Fab>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="MANUTENÇÃO SITES"
            />
        </Fragment>
    );
}
